import { format } from "date-fns";
import { Avatar, IconButton, Typography } from "@/components/atoms";
import { DataTableColumnDef } from "@/components/molecules";
import { Company } from "@/redux/slices/company/types";
import { getAssetUrl, getInitials } from "@/utils";
import { CompaniesAttachedTableData } from "./types";

export const generateCompaniesColumns = () => {
  const columns: DataTableColumnDef<CompaniesAttachedTableData>[] = [
    {
      accessorKey: "companyName",
      header: "Company Name",
      cell: (props) => props.row.original.companyName,
      enableSorting: false,
    },
    {
      accessorKey: "dateAttached",
      header: "Date Attached",
      cell: (props) => props.row.original.dateAttached,
      size: 200,
      enableSorting: false,
    },
    {
      accessorKey: "action",
      header: "",
      cell: (props) => props.row.original.action,
      size: 75,
      enableSorting: false,
    },
  ];

  return columns;
};

export const generateCompaniesData = (companies: Company[], onRemove: (company: Company) => void, dateFormat: string) => {
  const data = companies.map((company) => {
    return {
      companyName: (
        <div className="flex flex-row items-center gap-x-2">
          {renderCompanyAvatar(company)}
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            {company.name}
          </Typography>
        </div>
      ),
      dateAttached: company.pricing.profileAttachedAt ? format(new Date(company.pricing.profileAttachedAt), dateFormat) : "-",
      action: <IconButton variant="custom" iconName="Trash" className="text-danger" iconSize="lg" onClick={() => onRemove(company)} />,
    } as CompaniesAttachedTableData;
  });
  return data;
};

export const renderCompanyAvatar = (company: Company) => {
  const { avatar, name } = company;
  if (avatar) return <Avatar src={getAssetUrl(avatar, { height: 64, width: 64, fit: "cover" })} className="h-8 w-8" />;

  return (
    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-neutral-silver-gray text-white">
      <Typography variant="action">{getInitials(name)}</Typography>
    </div>
  );
};
